module.exports = __webpack_public_path__ + "img/logo.2556dad7.svg";